import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";
import { FilterSingle } from "./list.filter";

@Component({
  selector: "app-filter-single",
  templateUrl: "./filter.single.component.html",
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class FilterSingleComponent implements OnInit {
  _common = _common;

  @Input()
  filter = new FilterSingle();
  @Input()
  values: any[];
  @Input()
  names: string[];

  @Input()
  visible = true;
  @Input()
  set objectValues(c: any[]) {
    this.values = c.map((c) => c.id?.toString());
    this.names = c.map((c) => c.name);
  }

  @Input()
  set common(c: any) {
    this.names = this.values.map((v) => c[v] || v);
  }

  @Output()
  change = new EventEmitter<void>();

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["values"]) {
      if (!this.names) this.names = this.values;
    }
    this.filter._update();
  }

  refresh() {
    this.change.next(void 0);
  }
}
